import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "ae410d76-b570-4b07-8aa3-c91b5e9f4140", content: "0.44 mH", options: {} },
  { id: "4a2e96e9-1174-461e-a8f9-34748e0cca00", content: "0.48 mH", options: {} },
  { id: "76a832d3-a47f-439c-acb0-145f4dadf4e9", content: "0.56 mH", options: {} },
  { id: "3dd10092-8142-4f65-a7f8-45a624bd123f", content: "0.58 mH", options: {} },
];

export const task: Task = {
  id: "bd3db599-55e7-4d1f-9693-a1775bb4d406",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 4,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4a2e96e9-1174-461e-a8f9-34748e0cca00"],
};
